/**
 * Evento leve para abrir o dialog de "Primeiros passos" (onboarding) de qualquer
 * lugar do backoffice (botão do menu lateral, aviso na tela de Configuração) sem
 * acoplar os componentes. O <OnboardingDialog/> fica montado no AdminLayout e escuta.
 */
const EVENTO_ABRIR = 'onboarding:abrir';

export function abrirOnboarding(): void {
  window.dispatchEvent(new Event(EVENTO_ABRIR));
}

export function onAbrirOnboarding(cb: () => void): () => void {
  window.addEventListener(EVENTO_ABRIR, cb);
  return () => window.removeEventListener(EVENTO_ABRIR, cb);
}
